
import atlas from "@/components/atlas.vue";
import { eventUploadMixin } from '@/plugins/hwtag/events';
export default {
  mixins: [eventUploadMixin],
  data() {
    return {
      navId: 0,
      tab: 1,
      navActive:'CONTEST_INFO_TITLE',
      // 屏幕滚动
      scrollTop: 0,
      currentPage: 1,
      workCurrentPage: 1, // 当前页
      workPageSize: 9,    // 每页数量
      workTotal: 120,     // 总数
      workList: Array.from({ length: 120 }, (_, i) => i + 1),
      source: '',
      bannerH: 0,
      headerH: 0,
      WindowWidth:'',
      imgUrl: 'https://resource.xp-pen.com/img/Contest/AnniversaryContest25/',
      sidebar: 'en',
      sliderList: [
        {
          type: 'en',
          lang: 'English'
        },
        {
          type: 'de',
          lang: 'Deutsch'
        },
        {
          type: 'es',
          lang: 'Español'
        },
        {
          type: 'pt',
          lang: 'Português'
        },
        {
          type: 'it',
          lang: 'Italiano'
        },
        {
          type: 'fr',
          lang: 'Français'
        },
        {
          type: 'pl',
          lang: 'Polska'
        },
        {
          type: 'ru',
          lang: 'Русский язык'
        },
        {
          type: 'cz',
          lang: 'čeština'
        },
        {
          type: 'sk',
          lang: 'Slovák'
        },
        {
          type: 'id',
          lang: 'bahasa Indonesia'
        },
        {
          type: 'tw',
          lang: '繁体中文'
        }
      ],
      sidebarList: [
        'CONTEST_INFO_TITLE',
        "REVIEWER_TITLE",
        "REVIEW_MECHANISM_TITLE",
        "AWARD_TITLE"
      ],
      tooltipVisible: 0, // 用于控制奖项设置的tooltip显示
      isUploadFormExpired: false,
      isLargeImageVisible: false,
      currentLargeImage: '',
    };
  },
  head() {
    // 优化seo：动态设置title，keywords 和 description
    return {
      title: "Ultimate Set Design Contest",
      meta: [
        {
          name: "keywords",
          content: "Ultimate Set Design Contest, XPPen",
        },
        {
          hid: "description",
          name: "names",
          content: "Join for a chance to win a share of the $120,000 prize pool and XPPen flagship drawing tablet!",
        },
      ],
    };
  },
  components: { atlas },
  computed: {
    // 当前页显示的图片列表
    pagedWorkList() {
      const start = (this.workCurrentPage - 1) * this.workPageSize;
      return this.workList.slice(start, start + this.workPageSize);
    }
  },
  watch: {
    sidebar: {
      handler: function (val) {
        this.$i18n.locale = val
      },
      deep: true,
      immediate: true
    }

  },
  mounted() {
    this.WindowWidth = window.innerWidth;
    this.bannerH = this.$refs.bannerHeight.offsetHeight;
    this.headerH = document.getElementsByTagName('header')[0].offsetHeight;
    this.parametricWork();
    window.addEventListener('scroll', this.handleScroll, true);
    if (this.$route.query.lang) {
      let lang = this.$route.query.lang;
      if (lang == 'hk') {
        lang = 'tw';
      } else if (lang == 'vn') {
        lang = 'en';
      }
      this.changeLanguage(lang);
    }
    this.checkUploadFormExpiration();
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    // 作品方法
    async parametricWork(type, page = 1) {
      let res = await this.$global.parametricWork({ "activityId": 53, "page": page, "award": 0 });
      // res.code = '200' ? (this.source = res.result) : []
      this.source = res;
    },
    // 分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.parametricWork(28, this.currentPage);
    },
    handleWorkCurrentPage(val) {
      this.workCurrentPage = val;
    },
    // 滚动方法
    handleScroll() {
      this.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      const sections = this.sidebarList.map(item => document.getElementById(item));
      for (let i = sections.length - 1; i >= 0; i--) {
        const section = sections[i];
        if (section) {
          const offset = 300;
          if (this.scrollTop >= section.offsetTop - offset) {
            this.navActive = this.sidebarList[i];
            break;
          }
        }
      }
    },
    //侧边导航锚点滚动
    handleScrollTo(id) {
      const element = document.getElementById(id);
      const top = (element.getBoundingClientRect().top + window.pageYOffset) - 100;
      window.scroll({ top, behavior: 'smooth' });
      this.navActive = id;
      if(id === 'winner') {
        this.navId = 0;
      } else if(id === 'entries') {
        this.navId = 2;
      } else {
        this.navId = 1;
      }
    },
    //语言栏切换
    changeLanguage(lang) {
      this.sidebar = lang;
      this.$loadLanguageAsync(lang);
    },
    //rules tab
    handelTab (tabIndex) {
      this.tab = tabIndex;
    },
    showTooltip(id) {
      this.tooltipVisible = id;
    },
    hideTooltip() {
      this.tooltipVisible = 0;
    },
    checkUploadFormExpiration() {
      const expirationDate = new Date('2025-10-17T07:59:00')
      const now = new Date()
      this.isUploadFormExpired = now > expirationDate
    },
    showLargeImage(imageSrc) {
      this.currentLargeImage = imageSrc;
      this.isLargeImageVisible = true;
    },
    hideLargeImage() {
      this.isLargeImageVisible = false;
      this.currentLargeImage = '';
    },
  },
};
